var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imgUrl != null && _vm.imgUrl != '')?_c('div',{staticClass:"header-image w-1920"},[_c('Uimage',{attrs:{"src":_vm.imgUrl}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }